import { securityInvitationsResendPostAsyncSlice } from './post';

export const {
	requestPostSecurityInvitationsResend,
	resetPostSecurityInvitationsResend
} = securityInvitationsResendPostAsyncSlice.asyncActionCreators;
